import { Components } from '@mui/material/styles';
import MuiButton from './button';
import MuiCard from './card';
import MuiCardHeader from './cardheader';
import MuiCardContent from './cardcontent';
import MuiChip from './chip';
import MuiOutlinedInput from './outlinedinput';
import MuiTextField from './textfield';
import MuiSelect from './select';
import MuiFormControlLabel from './formcontrollabel';
import MuiInputBase from './inputbase';
import MuiTooltip from './tooltip';
import MuiTab from './tab';
import MuiDataGrid from './datagrid';
import MuiPagination from './pagination';
import MuiTouchRipple from './touchripple';
import MuiDivider from './divider'
import MuiMenuItem from './menuitems';
import MuiMenu from './menu';
import MuiIconButton from './iconbutton';
import MuiSwitch from './switch';

export const components = {
  MuiButton,
  MuiCard,
  MuiCardHeader,
  MuiCardContent,
  MuiChip,
  MuiOutlinedInput,
  MuiTextField,
  MuiSelect,
  MuiFormControlLabel,
  MuiInputBase,
  MuiTooltip,
  MuiTab,
  MuiDataGrid,
  MuiPagination,
  MuiTouchRipple,
  MuiDivider,
  MuiMenuItem,
  MuiMenu,
  MuiIconButton,
  MuiSwitch,
} as Partial<Components>;
